module.exports = __webpack_public_path__ + "img/care_guide_4.fd256478.png";